import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom';
import { NavLink, useNavigate } from 'react-router-dom';
import promoStyles from './css/promoBanner.module.css';

// ===================== M-PESA QUIZMASTER PROMO BANNER =====================
const promoText = {
    "0": {
        title: "Win money on M-Pesa with QuizMaster",
        dates: "15 Oct – 11 Nov 2026",
        prize: "Up to 20,000 MT",
        prizeSub: "in the final prize",
        play: "Play now",
        rules: "View terms & conditions",
        leaderboard: "Leaderboard",
        accept: "I accept the",
        acceptLink: "terms & conditions",
        popupTitle: "Before you play",
        popupText: "To take part in the M-Pesa QuizMaster promotion, please read and accept the terms & conditions.",
        popupAccept: "Accept & Play",
        popupCancel: "Cancel"
    },
    "3": {
        title: "Ganha dinheiro no M-Pesa com QuizMaster",
        dates: "15 Out – 11 Nov 2026",
        prize: "Até 20.000 MT",
        prizeSub: "no prémio final",
        play: "Jogar agora",
        rules: "Ver termos e condições",
        leaderboard: "Classificação",
        accept: "Aceito os",
        acceptLink: "termos e condições",
        popupTitle: "Antes de jogar",
        popupText: "Para participares na promoção M-Pesa QuizMaster, lê e aceita os termos e condições.",
        popupAccept: "Aceitar e Jogar",
        popupCancel: "Cancelar"
    },
};

const PromoBanner = ({ language, playLink = "/promo/quiz", rulesLink = "/promo/rules", leaderboardLink = "/promo/leaderboard" }) => {
    const navigate = useNavigate();
    const [imgError, setImgError] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(
        localStorage.getItem("promoTermsAccepted") === "1"
    );
    const [showPopup, setShowPopup] = useState(false);
    const [popupChecked, setPopupChecked] = useState(false);
    const text = promoText[language] || promoText["0"];

    // ===================== TERMS CHECKBOX =====================
    const handleTermsChange = (event) => {
        const checked = event.target.checked;
        setTermsAccepted(checked);
        localStorage.setItem("promoTermsAccepted", checked ? "1" : "0");
    };

    // ===================== PLAY CLICK → POPUP IF NOT ACCEPTED =====================
    const handlePlayClick = (event) => {
        if (!termsAccepted) {
            event.preventDefault();
            setPopupChecked(false);
            setShowPopup(true);
        }
    };

    const closePopup = () => {
        setShowPopup(false);
    };

    const handlePopupAccept = () => {
        if (!popupChecked) return;
        setTermsAccepted(true);
        localStorage.setItem("promoTermsAccepted", "1");
        setShowPopup(false);
        navigate(playLink);
    };

    // close popup on Esc + lock page scroll while open
    useEffect(() => {
        if (!showPopup) return;
        const onKey = (e) => { if (e.key === "Escape") closePopup(); };
        document.addEventListener("keydown", onKey);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = prevOverflow;
        };
    }, [showPopup]);

    return (
        <div className={promoStyles.promoCard}>
            <div className={promoStyles.promoTop}>
                <div className={promoStyles.promoInfo}>
                    <h3 className={promoStyles.promoTitle}>{text.title}</h3>
                    <p className={promoStyles.promoDates}>{text.dates}</p>
                    <div className={promoStyles.promoPrize}>
                        {text.prize}
                        <span className={promoStyles.promoPrizeSub}>{text.prizeSub}</span>
                    </div>
                </div>

                {!imgError ? (
                    <img
                        src="/image/promo-trophy.png"
                        alt=""
                        className={promoStyles.promoTrophy}
                        onError={() => setImgError(true)}
                    />
                ) : (
                    <span className={promoStyles.promoTrophyFallback} aria-hidden="true">🏆</span>
                )}
            </div>

            <NavLink
                to={playLink}
                onClick={handlePlayClick}
                className={promoStyles.promoButton}
            >
                {text.play}
                <span className={promoStyles.promoButtonArrow} aria-hidden="true">›</span>
            </NavLink>

            <NavLink to={leaderboardLink} className={promoStyles.promoLeaderboardButton}>
                {text.leaderboard}
                <span className={promoStyles.promoButtonArrow} aria-hidden="true">›</span>
            </NavLink>

            {/* ===================== TERMS & CONDITIONS CHECKBOX ===================== */}
            <label className={promoStyles.promoTerms}>
                <input
                    type="checkbox"
                    className={promoStyles.promoTermsCheckbox}
                    checked={termsAccepted}
                    onChange={handleTermsChange}
                />
                <svg className={promoStyles.promoRulesIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="8" y1="13" x2="16" y2="13" />
                    <line x1="8" y1="17" x2="16" y2="17" />
                </svg>
                <span>
                    {text.accept}{" "}
                    <NavLink to={rulesLink} className={promoStyles.promoRules}>
                        {text.acceptLink}
                    </NavLink>
                </span>
            </label>

            {/* ===================== ACCEPT TERMS POPUP ===================== */}
            {showPopup && createPortal(
                <div className={promoStyles.popupOverlay} onClick={closePopup}>
                    <div
                        className={promoStyles.popup}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="promo-terms-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className={promoStyles.popupIcon} aria-hidden="true">📋</div>
                        <h3 id="promo-terms-title" className={promoStyles.popupTitle}>{text.popupTitle}</h3>
                        <p className={promoStyles.popupText}>{text.popupText}</p>

                        <label className={promoStyles.popupCheck}>
                            <input
                                type="checkbox"
                                className={promoStyles.promoTermsCheckbox}
                                checked={popupChecked}
                                onChange={(e) => setPopupChecked(e.target.checked)}
                            />
                            <span>
                                {text.accept}{" "}
                                <NavLink to={rulesLink} className={promoStyles.popupLink}>
                                    {text.acceptLink}
                                </NavLink>
                            </span>
                        </label>

                        <button
                            type="button"
                            className={promoStyles.popupAccept}
                            onClick={handlePopupAccept}
                            disabled={!popupChecked}
                        >
                            {text.popupAccept}
                        </button>
                        <button
                            type="button"
                            className={promoStyles.popupCancel}
                            onClick={closePopup}
                        >
                            {text.popupCancel}
                        </button>
                    </div>
                </div>,
                document.body
            )}

        </div>
    );
};

export default PromoBanner